var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"position-fixed w-100 h-100",attrs:{"loader-component":""}},[_c('div',{staticClass:"d-flex w-100 h-100 align-items-center justify-content-center"},[_vm._t("default",function(){return [_c('i',{staticClass:"text-primary",class:_vm.faIconClasses})]})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }